import { render, staticRenderFns } from "./CopyUniversityDirectionModal.vue?vue&type=template&id=56057936&scoped=true&"
import script from "./CopyUniversityDirectionModal.vue?vue&type=script&lang=js&"
export * from "./CopyUniversityDirectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56057936",
  null
  
)

export default component.exports